var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg42(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12,
    fill: "#0000E3",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8932 14.9453V16.4453H4.6901L4.6276 15.3125L9.53385 7.625H11.0417L9.40885 10.4219L6.58854 14.9453H12.8932ZM11.4714 7.625V19H9.58854V7.625H11.4714ZM21.776 17.5V19H14.151V17.7109L17.8542 13.6719C18.2604 13.2135 18.5807 12.8177 18.8151 12.4844C19.0495 12.151 19.2135 11.8516 19.3073 11.5859C19.4063 11.3151 19.4557 11.0521 19.4557 10.7969C19.4557 10.4375 19.388 10.1224 19.2526 9.85156C19.1224 9.57552 18.9297 9.35938 18.6745 9.20312C18.4193 9.04167 18.1094 8.96094 17.7448 8.96094C17.3229 8.96094 16.9688 9.05208 16.6823 9.23438C16.3958 9.41667 16.1797 9.66927 16.0339 9.99219C15.888 10.3099 15.8151 10.6745 15.8151 11.0859H13.9323C13.9323 10.4245 14.0833 9.82031 14.3854 9.27344C14.6875 8.72135 15.125 8.28385 15.6979 7.96094C16.2708 7.63281 16.9609 7.46875 17.7682 7.46875C18.5286 7.46875 19.1745 7.59635 19.7057 7.85156C20.237 8.10677 20.6406 8.46875 20.9167 8.9375C21.1979 9.40625 21.3385 9.96094 21.3385 10.6016C21.3385 10.9557 21.2813 11.3073 21.1667 11.6562C21.0521 12.0052 20.888 12.3542 20.6745 12.7031C20.4661 13.0469 20.2188 13.3932 19.9323 13.7422C19.6458 14.0859 19.3307 14.4349 18.987 14.7891L16.526 17.5H21.776Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg42);
export default __webpack_public_path__ + "static/media/42.a56e5bca234aebe36468b7806e266c33.svg";
export { ForwardRef as ReactComponent };